import { t } from '@/libs/i18n';

// Los datos que se pasan son directramente los que usamos con swal
export default {
  beforeMount(el, bindings, _vnode) {
    // Si es false no es obligatorio, no hacemos nada
    if (bindings.value === false) {
      return;
    }

    const abbr = document.createElement('abbr');
    abbr.textContent = '*';
    abbr.className = 'required m-r-xs';
    abbr.dataset.toggle = 'tooltip';
    abbr.title = t('requerido')
    el.insertBefore(abbr, el.firstChild);
  },
};
